/**
 * The authenticator app's code: when a session owes it, and how a refused
 * code reads (2026-10-13). The gate asks for it after every first step (the
 * email code, Google or a passkey) once an account has an app; the set-up
 * asks for it to turn the app on. Both word a refusal the same way.
 */

/** The account has an authenticator app and this session has not given its code. */
export function owesAppCode(level: { currentLevel: string | null; nextLevel: string | null } | null | undefined): boolean {
  return !!level && level.nextLevel === 'aal2' && level.currentLevel !== 'aal2';
}

/** The sentence for a refused app code, in plain words. */
export function appCodeErrorMessage(error: unknown): string {
  const e = error as { code?: string; message?: string } | null;
  if (e?.code === 'mfa_verification_failed' || /invalid|expired|mismatch/i.test(e?.message ?? '')) {
    return 'That code did not match. Codes change every 30 seconds: enter the one your app shows now.';
  }
  return e?.message || 'The code could not be checked. Try again.';
}
